<template>
  <div class="elite-tabs-wrapper-content">
    <div :class="'title-header ' + (isOut ? 'out' : 'in')">
      <div class="row">
        <div class="flex justify-center col-3">
          <in-out-badge class="float-left mr-3" :type="transaction.transaction_type" />
        </div>

        <div class="col-9 text-right">
          <base-button
            type="button"
            size="sm"
            @click="toggleOnHold(transaction)"
            class="elite-button add"
            v-if="
              transaction.status != STATUS_COMPLETED &&
              (transaction.status == STATUS_PENDING ||
                transaction.status == STATUS_HOLDON)
            "
          >
            <div v-if="transaction.status == STATUS_PENDING">
              <span class="btn-inner--icon">
                <i class="far fa-stop"></i>
              </span>
              <span class="btn-inner--text">
                {{ $t("PAYMENTS.PUT_ON_HOLD") }}
              </span>
            </div>
            <!-- <div v-if="transaction.status == STATUS_HOLDON"> -->
            <div v-else>
              <span class="btn-inner--icon">
                <i class="far fa-plus"></i>
              </span>
              <span class="btn-inner--text">
                {{ $t("PAYMENTS.PUT_ON_PENDING") }}
              </span>
            </div>
          </base-button>
          <base-button
            type="button"
            size="sm"
            @click="validateTransaction(transaction)"
            class="elite-button add"
            v-if="transaction.status != STATUS_COMPLETED"
          >
            <span class="btn-inner--icon">
              <i class="far fa-check"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.VALIDATE") }}
            </span>
          </base-button>
          <base-button
            type="button"
            size="sm"
            @click="cancelTransaction(transaction)"
            class="elite-button add"
          >
            <span class="btn-inner--icon">
              <i class="far fa-times"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.CANCEL") }}
            </span>
          </base-button>
          <base-button
            class="btn-outline-danger elite-button add"
            icon
            size="sm"
            v-if="
              transaction.status == STATUS_DRAFT &&
              $currentUserCan($permissions.PERM_DELETE_TRANSACTIONS_DPA)
            "
            @click="deleteTransaction"
          >
            <span class="btn-inner--icon">
              <i class="far fa-trash-alt"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.DELETE") }}
            </span>
          </base-button>
        </div>
      </div>
    </div>

    <div class="all-infos">
      <div class="all-infos-text">
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.DATE") }}</dt>
          <dd class="col-sm-8">
            {{ $timeZoneDateFormat(transaction.created_at) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.STATUS") }}</dt>
          <dd class="col-sm-8">
            <status-badge :data="transaction" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.AMOUNT") }}</dt>
          <dd class="col-sm-8">
            <amount-badge
              :type="isOut ? 'OUT' : 'IN'"
              :amount="transaction.amount"
            />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd class="col-sm-8" v-if="transaction.created_at">
            {{ $timeZoneDateFormat(transaction.created_at) }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd class="col-sm-8" v-if="transaction.updated_at">
            {{ $timeZoneDateFormat(transaction.updated_at) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import StatusBadge from "../components/StatusBadge.vue";
import {
  STATUS_DRAFT,
  STATUS_PENDING,
  STATUS_COMPLETED,
  STATUS_HOLDON,
} from "@/constants/transactions";
import InOutBadge from "../components/atoms/InOutBadge.vue";
import AmountBadge from "../components/atoms/AmountBadge.vue";
export default {
  name: "transaction-view-global",

  components: {
    StatusBadge,
    InOutBadge,
    AmountBadge,
  },

  props: ["transaction"],

  data() {
    return {
      STATUS_DRAFT: STATUS_DRAFT,
      STATUS_PENDING: STATUS_PENDING,
      STATUS_HOLDON: STATUS_HOLDON,
      STATUS_COMPLETED: STATUS_COMPLETED,
    };
  },

  computed: {
    isOut() {
      return this.transaction.transaction_type == "RETRAIT";
    },
  },

  created() {
    console.log(this.transaction);
  },

  methods: {
    validateTransaction() {
      this.$emit("onValidateTransaction", this.transaction);
    },
    cancelTransaction() {
      this.$emit("onCancelTransaction", this.transaction);
    },
    editTransaction() {
      this.$emit("onEditTransaction", this.transaction);
    },
    deleteTransaction() {
      this.$emit("onDeleteTransaction", this.transaction);
    },
    toggleOnHold() {
      this.$emit("onToggleOnHold", [this.transaction]);
    },
    sendTransactionsToDpa() {
      this.$emit("onSendTransactionsToDpa", [this.transaction]);
    },
  },

  mounted() {},

  watch: {
    transaction(transaction) {},
  },
};
</script>
